/**
 * Utilities for VersionBadge — pure functions extracted to satisfy
 * react-refresh/only-export-components lint rule.
 */

export interface VersionInfo {
  /** Versão sem o "v" (ex.: "0.0.42") — exibido quando a sidebar está colapsada */
  displayShort: string;
  /** Texto completo exibido na sidebar expandida */
  displayFull: string;
  /** Conteúdo do tooltip (versão + branch + commit) */
  tooltipContent: string;
  /** Determina a cor do badge */
  variant: 'default' | 'hotfix' | 'dev';
}

export function parseVersionInfo(env: {
  VITE_APP_VERSION?: string;
  VITE_GIT_COMMIT?: string;
  VITE_RELEASE_BRANCH?: string;
}): VersionInfo {
  const version = env.VITE_APP_VERSION ?? '';
  const commit = env.VITE_GIT_COMMIT || 'local';
  const branch = env.VITE_RELEASE_BRANCH || 'none';

  // Dev / fallback: sem versão real
  if (!version || version === '0.0.0') {
    return {
      displayShort: 'dev',
      displayFull: 'dev · local',
      tooltipContent: 'dev build\nbranch: local\ncommit: local',
      variant: 'dev',
    };
  }

  const commitShort = commit.slice(0, 7);
  const baseVersion = version.split('+hotfix.')[0];
  // Colapsada: mostra a versão (sem o "v" para caber no espaço estreito),
  // não o hash do commit.
  const displayShort = baseVersion;

  // Hotfix: versão contém "+hotfix."
  if (version.includes('+hotfix.')) {
    const hotfixCount = version.split('+hotfix.')[1];
    const displayFull = `v${baseVersion} (hotfix.${hotfixCount}) · ${commitShort}`;
    return {
      displayShort,
      displayFull,
      tooltipContent: `${displayFull}\nbranch: ${branch}\ncommit: ${commit}`,
      variant: 'hotfix',
    };
  }

  // Release limpo
  const displayFull = `v${version} · ${commitShort}`;
  return {
    displayShort,
    displayFull,
    tooltipContent: `${displayFull}\nbranch: ${branch}\ncommit: ${commit}`,
    variant: 'default',
  };
}
